"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsoleLogger = void 0;
exports.buildConsoleLogger = buildConsoleLogger;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.number.constructor.js");
var _contracts = require("./contracts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger(context) {
    _classCallCheck(this, ConsoleLogger);
    _defineProperty(this, "context", void 0);
    this.context = context || {};
  }
  _createClass(ConsoleLogger, [{
    key: "formatMessage",
    value: function formatMessage(message, level, context) {
      var msg = '[' + _contracts.LogLevel[level].toUpperCase() + '] ';
      if (context && context.app) {
        msg += context.app + ': ';
      }
      if (typeof message === 'string') return msg + message;

      // basic error formatting
      msg += "Unexpected ".concat(message.name);
      if (message.message) msg += " \"".concat(message.message, "\"");
      // only add stack trace when debugging
      if (level === _contracts.LogLevel.Debug && message.stack) msg += "\n\nStack trace:\n".concat(message.stack);
      return msg;
    }
  }, {
    key: "log",
    value: function log(level, message, context) {
      var _this$context, _this$context2;
      // Skip if level is configured and this is below the level
      if (typeof ((_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.level) === 'number' && level < ((_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.level)) {
        return;
      }

      // Add error object to context
      if (_typeof(message) === 'object' && (context === null || context === void 0 ? void 0 : context.error) === undefined) {
        context.error = message;
      }
      switch (level) {
        case _contracts.LogLevel.Debug:
          console.debug(this.formatMessage(message, _contracts.LogLevel.Debug, context), context);
          break;
        case _contracts.LogLevel.Info:
          console.info(this.formatMessage(message, _contracts.LogLevel.Info, context), context);
          break;
        case _contracts.LogLevel.Warn:
          console.warn(this.formatMessage(message, _contracts.LogLevel.Warn, context), context);
          break;
        case _contracts.LogLevel.Error:
          console.error(this.formatMessage(message, _contracts.LogLevel.Error, context), context);
          break;
        case _contracts.LogLevel.Fatal:
        default:
          console.error(this.formatMessage(message, _contracts.LogLevel.Fatal, context), context);
          break;
      }
    }
  }, {
    key: "debug",
    value: function debug(message, context) {
      this.log(_contracts.LogLevel.Debug, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "info",
    value: function info(message, context) {
      this.log(_contracts.LogLevel.Info, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "warn",
    value: function warn(message, context) {
      this.log(_contracts.LogLevel.Warn, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "error",
    value: function error(message, context) {
      this.log(_contracts.LogLevel.Error, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "fatal",
    value: function fatal(message, context) {
      this.log(_contracts.LogLevel.Fatal, message, Object.assign({}, this.context, context));
    }
  }]);
  return ConsoleLogger;
}();
/**
 * Create a new console logger
 *
 * @param context Optional global context which should be included for all logging messages
 */
exports.ConsoleLogger = ConsoleLogger;
function buildConsoleLogger(context) {
  return new ConsoleLogger(context);
}
//# sourceMappingURL=ConsoleLogger.js.map